/* eslint-disable react/no-array-index-key */
import Skeleton from 'components/Skeleton';
import useStyles from './styles';

function HeaderBannerWithCTAAndBulletsSkeleton() {
  const styles = useStyles();

  return (
    <div className={styles.skeletonRoot}>
      <Skeleton />
    </div>
  );
}

export default HeaderBannerWithCTAAndBulletsSkeleton;
